import { Component } from '@angular/core';
import { OrganizationService } from 'services/organization/organization.service';

@Component({
  selector: 'ems-organization-name',
  templateUrl: './organization-name.component.html',
  styleUrls: ['./organization-name.component.scss']
})
export class OrganizationNameComponent {

  public get Name(): string {
    return this.organizationService.Name
  }

  constructor(
    private organizationService: OrganizationService,
  ) { }
}
